import React, { Component } from "react";
import {
  message,
  PageHeader,
  Spin,
  Row,
  Col,
  Divider,
  Select,
  Tooltip,
  Checkbox,
  Collapse,

  Form as FormInitial,
  Tag,
} from "antd";
import {
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  DatePickerItem,
  NotificacionPolizas,
  NotificacionMovimientosInventario,
  ButtonItem,
  ErrorItem,
  round10Decimals,
  SwitchItem,
  TextAreaItem
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { ArrowUpOutlined, CalculatorOutlined, FireOutlined, WarningOutlined, CloseCircleOutlined, InboxOutlined, CommentOutlined } from "@ant-design/icons";
import ElegirObservaciones from "../../Ventas/ElegirObservaciones/ElegirObservaciones";
import ModalApartadoPedidoPdf from "../ModalApartadoPedidoPdf/ModalApartadoPedidoPdf";


const { Option } = Select;
const { Panel } = Collapse;

moment.locale("es");

class RequerirInsumosPedido extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    datosPedido: undefined,
    todasInsumos: null,
    objetoInsumos: null,
    todasProyectos: null,
    objetoProyectos: null,
    id: this.props.location.state.pedidoId,
    modoMasivo: !!this.props.location.state.pedidosIds,
    pedidosIds: this.props.location.state.pedidosIds || [],
    pedidosInfo: [],
    excluidos: [],
    advertencias: [],
    resultadosApartado: null,
    apartarCantidades: {},
    modalApartadoPdf: false,
    apartadoAhora: [],
    volverAlCerrarPdf: false,
    modalObservaciones: false,
    modalObservacionesIndex: null,
    modalObservacionesObservaciones: null,
    modalObservacionesObservacionesPasadas: null,
    clienteIdActual: null,
  };
  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    const endpoint = this.state.modoMasivo ? "pedidos/datosPedidosPRecibirPMasivo" : "pedidos/datosPedidoPRecibirP";
    const payload = this.state.modoMasivo
      ? { empresaId: this.props.empresaId, pedidosIds: this.state.pedidosIds }
      : { empresaId: this.props.empresaId, pedidoId: this.state.id };

    await axios
      .post(endpoint, payload, { headers: this.props.headersToken })
      .then(async (res) => {
        if (res.data.success === 2) {
          const pedidoInsumos = this.state.modoMasivo ? res.data.insumos : (res.data.pedido.insumos || []);
          const catalogoInsumos = this.state.modoMasivo ? res.data.todasInsumos : res.data.insumos;

          // Consulta de inventarios en bulk (respeta el proyecto de cada linea y las equivalencias/compuestos)
          const insumosBulk = pedidoInsumos.map((row, index) => {
            const insumoOriginal = catalogoInsumos.find(i => i._id.toString() === row.insumoId.toString());
            return {
              index,
              insumoId: row.insumoId,
              proyectoId: row.proyectoId,
              inventariable: insumoOriginal?.inventariable,
              noPrincipal: insumoOriginal?.noPrincipal,
              insumoCompuesto: insumoOriginal?.insumoCompuesto,
              componentesKit: row.componentesKit,
            };
          });

          let inventarioPorLinea = pedidoInsumos.map(() => 0);
          try {
            const resInventarios = await axios.post(
              "inventarios/inventarioInsumoProyectoBulk",
              { empresaId: this.props.empresaId, insumos: insumosBulk },
              { headers: this.props.headersToken }
            );
            if (resInventarios.data?.results) {
              resInventarios.data.results.forEach(r => {
                inventarioPorLinea[r.index] = r.cantidad || 0;
              });
            }
          } catch (e) {
            console.error("Error al consultar inventario bulk", e);
          }

          const datosPedido = this.state.modoMasivo
            ? {
              insumos: pedidoInsumos.map((value, index) => ({
                ...value,
                inventario: inventarioPorLinea[index],
              })),
            }
            : {
              ...res.data.pedido,
              insumos: pedidoInsumos.map((value, index) => ({
                ...value,
                inventario: inventarioPorLinea[index],
              })),
            };

          this.setState({
            datosPedido,
            pedidosInfo: this.state.modoMasivo ? res.data.pedidos : [],
            excluidos: this.state.modoMasivo ? res.data.excluidos : [],
            advertencias: this.state.modoMasivo ? res.data.advertencias : [],
            todasInsumos: catalogoInsumos,
            todasProyectos: res.data.proyectos || [],
            objetoInsumos: catalogoInsumos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.stringBuscar}
                </Option>
              );
            }),
          });

          this.formRef.current.setFieldsValue({
            insumos: datosPedido.insumos.map(value => ({
              ...value,
              precioUnitarioAjustado: (value.precioUnitario * (1 - (value.descuento / 100))),
              fechaEntrega: this.state.modoMasivo
                ? moment(value.fechaEntregaEstimada || undefined)
                : undefined,
            }))
          });

          if (!this.state.modoMasivo && datosPedido.fechaEntregaEstimada) {
            this.formRef.current.setFieldsValue({
              fechaEntrega: moment(datosPedido.fechaEntregaEstimada),
            });
          }

        } else {
          message.error(res.data.message || "Error no se encontró información del/los pedido(s)");
        }
      });
    this.setState({ loading: false });
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  async onFinish(values) {
    let requerirTodos = 0;
    values.insumos = values.insumos.map(value => {
      let requerir = value.requerir ? value.requerir : 0
      requerirTodos += requerir
      return { ...value, requerir, observaciones: value.observaciones || "" }
    })
    const lineasApartar = Object.entries(this.state.apartarCantidades)
      .map(([idx, apartarCantidad]) => ({ idx: Number(idx), apartarCantidad: Number(apartarCantidad) || 0 }))
      .filter(v => v.apartarCantidad > 0);

    if (requerirTodos === 0 && lineasApartar.length === 0) {
      return message.info('Se neceitan cantidades para poder hacer esta operación')
    }

    this.setState({ loading: true, resultadosApartado: null });

    //Comprometer lo capturado en "Apartar"
    const fallosApartado = [];
    const apartadoAhora = [];
    for (const linea of lineasApartar) {
      const insumoBase = this.state.datosPedido?.insumos?.[linea.idx];
      if (!insumoBase) continue;
      const pedidoId = this.state.modoMasivo ? insumoBase.pedidoId : this.state.id;
      try {
        const res = await axios.post(
          "pedidos/apartarInsumos",
          {
            empresaId: this.props.empresaId,
            pedidoId,
            insumos: [{ _id: insumoBase._id, apartar: linea.apartarCantidad, proyectoId: insumoBase.proyectoId }],
          },
          { headers: this.props.headersToken }
        );
        if (res.data.success === 2) {
          NotificacionMovimientosInventario(res.data.movimientosIds);
          apartadoAhora.push({ lineaId: insumoBase._id, cantidad: linea.apartarCantidad });
        } else {
          fallosApartado.push({ pedidoNumero: insumoBase.pedidoNumero, insumo: this.nombreInsumo(insumoBase.insumoId), motivo: res.data.message || "No se pudo apartar" });
        }
      } catch (e) {
        fallosApartado.push({ pedidoNumero: insumoBase.pedidoNumero, insumo: this.nombreInsumo(insumoBase.insumoId), motivo: "Error al apartar" });
      }
    }

    if (fallosApartado.length > 0) {
      message.warning(`${fallosApartado.length} línea(s) no se pudieron apartar (sin inventario suficiente)`);
      this.setState({ resultadosApartado: fallosApartado });
    }

    if (requerirTodos === 0) {
      this.setState({ loading: false });
      if (lineasApartar.length > fallosApartado.length) message.success('Se apartaron los insumos');
      this.mostrarPdfApartadoOTerminar(apartadoAhora, fallosApartado.length === 0);
      return;
    }

    const endpoint = this.state.modoMasivo ? "pedidos/requerirInsumosMasivo" : "pedidos/requerirInsumos";
    const payload = this.state.modoMasivo
      ? { ...values, empresaId: this.props.empresaId, pedidosIds: this.state.pedidosIds }
      : { ...values, empresaId: this.props.empresaId, pedidoId: this.state.id };
    axios
      .post(endpoint, payload, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            "Se Ha generado la requisicion " + res.data.requisicionNumero
          );
          NotificacionPolizas(res.data.polizasId)
          this.formRef.current.resetFields();
          this.mostrarPdfApartadoOTerminar(apartadoAhora, true);
        } else if (res.data.success === 1) {
          message.error(res.data.message ? res.data.message : "No se pueden requerir los insumos");
          this.mostrarPdfApartadoOTerminar(apartadoAhora, false);
        } else {
          message.error("Hubo un error y no se requirieron los insumos");
          this.mostrarPdfApartadoOTerminar(apartadoAhora, false);
        }
      });
  }
  atras() {
    this.props.history.goBack();
  }
  // Complemento pdfApartadoPedido: si se aparto algo muestra el PDF (solo con un pedido, no en
  // modo masivo) y al cerrarlo regresa si `volver`; sin PDF regresa directo si `volver`.
  mostrarPdfApartadoOTerminar(apartadoAhora, volver) {
    if (this.props.pdfApartadoPedido && !this.state.modoMasivo && apartadoAhora.length > 0) {
      this.setState({ modalApartadoPdf: true, apartadoAhora, volverAlCerrarPdf: volver });
    } else if (volver) {
      this.atras();
    }
  }
  cerrarApartadoPdf() {
    const volver = this.state.volverAlCerrarPdf;
    this.setState({ modalApartadoPdf: false, apartadoAhora: [], volverAlCerrarPdf: false });
    if (volver) this.atras();
  }
  toggleCopiarObservacionesPedido(e) {
    const checked = e.target.checked;
    this.formRef.current.setFieldsValue({
      observaciones: checked ? (this.state.datosPedido?.observaciones || "") : "",
    });
  }
  abrirObservaciones(index) {
    const insumosForm = this.formRef.current.getFieldValue('insumos') || [];
    const insumoFila = insumosForm[index];

    const insumoCat = this.state.todasInsumos?.find(i => i._id === insumoFila?.insumoId);
    const observacionesPasadas = insumoCat?.observacionesPasadas || [];

    this.setState({
      modalObservaciones: true,
      modalObservacionesIndex: index,
      modalObservacionesObservaciones: insumoFila?.observaciones,
      modalObservacionesObservacionesPasadas: observacionesPasadas,
      clienteIdActual: insumoFila?.clienteId || this.state.datosPedido?.clienteId,
    });
  }
  cerrarObservaciones(value) {
    const insumos = this.formRef.current.getFieldValue("insumos");
    insumos[this.state.modalObservacionesIndex].observaciones = value;
    this.formRef.current.setFieldsValue({
      insumos: insumos,
    });
    this.setState({
      modalObservaciones: false,
      modalObservacionesIndex: null,
      modalObservacionesObservaciones: null,
      modalObservacionesObservacionesPasadas: null,
      clienteIdActual: null,
    });
  }
  calcularRequerirFaltante(fieldKey) {
    //Calcular el faltante por entregar y lo que hay en inventario.
    //Requerir el minimo entre ambos.
    //Si no hay inventario, requerir el faltante.
    const form = this.formRef.current;
    const insumo = this.state.datosPedido?.insumos[fieldKey];
    if (!insumo) return;

    const { inventarioPreview, apartadoPreview } = this.calcularPreviewFila(fieldKey);

    //  Calcular cuánto se debe REQUERIR después de usar el inventario
    const cantidadARequerir = this.cantidadRequerirFaltante({ ...insumo, inventario: inventarioPreview, apartado: apartadoPreview });

    const insumosActuales = form.getFieldValue('insumos') || [];
    const nuevosInsumos = [...insumosActuales];

    nuevosInsumos[fieldKey] = {
      ...nuevosInsumos[fieldKey],
      requerir: cantidadARequerir,
    };

    form.setFieldsValue({ insumos: nuevosInsumos });
    //form.validateFields([['insumos', fieldKey, 'requerir']]).catch(() => { });

  }
  calcularRequerirTotal(fieldKey) {
    //Requerir el total de la venta sin importar si hay inventario o no. 
    const form = this.formRef.current;
    const datosPedido = this.state.datosPedido;
    if (!datosPedido?.insumos[fieldKey]) return;
    const insumo = datosPedido.insumos[fieldKey];
    if (!insumo) return;
    //La cantidad a requerir es la cantidad vendida.
    const cantidadARequerir = this.cantidadRequerirTotal(insumo);

    const insumosActuales = form.getFieldValue('insumos') || [];
    const nuevosInsumos = [...insumosActuales];
    //Directamente pone la cantidad a requerir como la cantidad vendida.
    nuevosInsumos[fieldKey] = {
      ...nuevosInsumos[fieldKey],
      requerir: cantidadARequerir,
    };

    form.setFieldsValue({ insumos: nuevosInsumos });

  }

  calcularTodosLosInsumos = (tipoCalculo) => {
    const form = this.formRef.current;
    const insumosActuales = form.getFieldValue('insumos') || [];
    //Veficicar que haya insumos actuales
    if (insumosActuales.length === 0) return;
    const datosPedidoInsumos = this.state.datosPedido?.insumos || [];
    const nuevosInsumos = insumosActuales.map((insumo, index) => {
      // Se indexa por posicion (no por insumoId) porque un mismo insumo puede
      // repetirse en varias lineas con proyectos distintos y por lo tanto inventarios distintos.
      const insumoDatos = datosPedidoInsumos[index];
      if (!insumoDatos) return insumo;
      let cantidadARequerir;
      if (tipoCalculo === 'faltante') {
        const { inventarioPreview, apartadoPreview } = this.calcularPreviewFila(index);
        cantidadARequerir = this.cantidadRequerirFaltante({ ...insumoDatos, inventario: inventarioPreview, apartado: apartadoPreview });
      }
      else if (tipoCalculo === 'total') {
        cantidadARequerir = this.cantidadRequerirTotal(insumoDatos);
      }
      return {
        ...insumo,
        requerir: cantidadARequerir,
      };
    });
    form.setFieldsValue({ insumos: nuevosInsumos });

  }

  //funciones para calcular la cantidad a requerir
  //Si se modfician modifica el calculo en los botones individuales y en el de todos los insumos.
  cantidadRequerirFaltante = (insumo) => {
    const cantidadVendida = insumo.cantidad || 0;
    const apartado = insumo.apartado || 0;
    const entregado = insumo.entregado || 0;
    const inventarioDisponible = insumo.inventario || 0;

    const faltantePorEntregar = Math.max(0, cantidadVendida - apartado - entregado);
    return Math.max(0, faltantePorEntregar - inventarioDisponible);
  }
  cantidadRequerirTotal = (insumo) => {
    return insumo.cantidad || 0;
  }

  //funciones de simulación local para "Apartar" (se confirma hasta onFinish)
  estaBloqueadoPorLotes = (insumoId) => {
    const insumoCatalogo = this.state.todasInsumos?.find(i => i._id === insumoId);
    return !!(insumoCatalogo?.lotesCaducidades || insumoCatalogo?.marbetes || insumoCatalogo?.agrupaciones);
  }
  nombreInsumo = (insumoId) => {
    return this.state.todasInsumos?.find(i => i._id === insumoId)?.stringBuscar || insumoId;
  }
  nombreProyecto = (proyectoId) => {
    return this.state.todasProyectos?.find(p => p._id === proyectoId)?.nombre || "—";
  }
  calcularPreviewFila = (fieldKey, apartarCantidades = this.state.apartarCantidades) => {
    const base = this.state.datosPedido?.insumos || [];
    const baseRow = base[fieldKey];
    if (!baseRow) return { inventarioPreview: 0, apartadoPreview: 0 };

    let totalGrupo = 0;
    base.forEach((otraBase, idx) => {
      if (otraBase.insumoId?.toString() === baseRow.insumoId?.toString() && otraBase.proyectoId?.toString() === baseRow.proyectoId?.toString()) {
        totalGrupo += Number(apartarCantidades[idx]) || 0;
      }
    });

    const inventarioPreview = Math.max(0, round10Decimals((baseRow.inventario || 0) - totalGrupo));
    const apartarPropio = Number(apartarCantidades[fieldKey]) || 0;
    const apartadoPreview = round10Decimals((baseRow.apartado || 0) + apartarPropio);
    return { inventarioPreview, apartadoPreview };
  }
  maxApartarLinea = (fieldKey, apartarCantidades = this.state.apartarCantidades) => {
    const base = this.state.datosPedido?.insumos || [];
    const baseRow = base[fieldKey];
    if (!baseRow) return 0;
    const faltantePorEntregar = Math.max(0, (baseRow.cantidad || 0) - (baseRow.apartado || 0) - (baseRow.entregado || 0));

    let totalOtrasLineas = 0;
    base.forEach((otraBase, idx) => {
      if (idx === fieldKey) return;
      if (otraBase.insumoId?.toString() === baseRow.insumoId?.toString() && otraBase.proyectoId?.toString() === baseRow.proyectoId?.toString()) {
        totalOtrasLineas += Number(apartarCantidades[idx]) || 0;
      }
    });
    const inventarioDisponibleParaEstaLinea = Math.max(0, round10Decimals((baseRow.inventario || 0) - totalOtrasLineas));
    return round10Decimals(Math.max(0, Math.min(faltantePorEntregar, inventarioDisponibleParaEstaLinea)));
  }
  onChangeApartarCantidad = (fieldKey, value) => {
    this.setState(prev => ({ apartarCantidades: { ...prev.apartarCantidades, [fieldKey]: value || 0 } }));
  }
  llenarMaximoApartarTodos = () => {
    const datosPedidoInsumos = this.state.datosPedido?.insumos || [];
    const nuevo = {};
    let huboOmitidos = false;

    for (let index = 0; index < datosPedidoInsumos.length; index++) {
      const insumoDatos = datosPedidoInsumos[index];
      if (!insumoDatos?.proyectoId || this.estaBloqueadoPorLotes(insumoDatos?.insumoId)) {
        huboOmitidos = true;
        continue;
      }
      nuevo[index] = this.maxApartarLinea(index, nuevo);
    }

    this.setState({ apartarCantidades: nuevo });
    if (huboOmitidos) message.info('Se omitieron líneas sin proyecto o con manejo de lotes/marbetes');
  }

  render() {
    const isMobile = window.innerWidth <= 1000;
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Requerir Insumos sobre Pedido"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            !this.state.modoMasivo &&
            <h1>
              Fecha:{" "}
              {moment(this.state.datosPedido?.createdAt).format("LL")}
            </h1>
          }
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="requerirInsumosFactura"
              layout
              bottom={
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Requerir
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              {this.state.modoMasivo ? (
                <>
                  <Row>
                    <Col span={24}>
                      <h1 style={{ margin: 0 }}>
                        Requisición combinada de {this.state.pedidosInfo.length} pedido(s)
                      </h1>
                      <Collapse ghost expandIconPosition="right" style={{ marginTop: 4 }}>
                        <Panel header={`Ver los ${this.state.pedidosInfo.length} pedidos incluidos`} key="1">
                          <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                            {this.state.pedidosInfo.map((p) => (
                              <Tag key={p._id}>
                                {p.pedidoNumero} — {p.cliente?.persona ? p.cliente?.razonSocial : `${p.cliente?.nombre || ""} ${p.cliente?.apellidoPaterno || ""}`.trim()}
                              </Tag>
                            ))}
                          </div>
                        </Panel>
                      </Collapse>
                    </Col>
                  </Row>
                  {this.state.excluidos.length > 0 &&
                    <div style={{ marginTop: 10, border: "1px solid #ffccc7", background: "#fff2f0", borderRadius: 8 }}>
                      <Collapse ghost expandIconPosition="right">
                        <Panel
                          header={
                            <span style={{ color: "#cf1322", fontWeight: 600 }}>
                              <CloseCircleOutlined style={{ marginRight: 8 }} />
                              {this.state.excluidos.length} pedido(s) excluidos automáticamente
                            </span>
                          }
                          key="1"
                        >
                          <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                            {this.state.excluidos.map((e) => (
                              <Tooltip key={e._id} title={e.motivo}>
                                <Tag color="red">{e.numero}</Tag>
                              </Tooltip>
                            ))}
                          </div>
                        </Panel>
                      </Collapse>
                    </div>}
                  {this.state.advertencias.length > 0 &&
                    <div style={{ marginTop: 10, border: "1px solid #ffe58f", background: "#fffbe6", borderRadius: 8 }}>
                      <Collapse ghost expandIconPosition="right">
                        <Panel
                          header={
                            <span style={{ color: "#ad6800", fontWeight: 600 }}>
                              <WarningOutlined style={{ marginRight: 8 }} />
                              {this.state.advertencias.length} pedido(s) ya tienen una requisición previa
                            </span>
                          }
                          key="1"
                        >
                          <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                            {this.state.advertencias.map((a) => (
                              <Tooltip key={a._id} title={a.motivo}>
                                <Tag color="orange">{a.numero}</Tag>
                              </Tooltip>
                            ))}
                          </div>
                        </Panel>
                      </Collapse>
                    </div>}
                </>
              ) : null}
              {this.state.resultadosApartado?.length > 0 &&
                <div style={{ marginTop: 10, border: "1px solid #ffccc7", background: "#fff2f0", borderRadius: 8 }}>
                  <Collapse ghost expandIconPosition="right">
                    <Panel
                      header={
                        <span style={{ color: "#cf1322", fontWeight: 600 }}>
                          <CloseCircleOutlined style={{ marginRight: 8 }} />
                          {this.state.resultadosApartado.length} línea(s) no se pudieron apartar
                        </span>
                      }
                      key="1"
                    >
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                        {this.state.resultadosApartado.map((f, i) => (
                          <Tooltip key={i} title={f.motivo}>
                            <Tag color="red">{(f.pedidoNumero ? f.pedidoNumero + " — " : "") + f.insumo}</Tag>
                          </Tooltip>
                        ))}
                      </div>
                    </Panel>
                  </Collapse>
                </div>}
              {!this.state.modoMasivo && (
                <Row >
                  <Col xs={24} sm={24} lg={isMobile ? 24 : 6} xl={isMobile ? 24 : 6}>
                    <h1 style={{ margin: 0 }}>
                      Proyecto: {this.state.datosPedido?.proyecto.nombre}
                    </h1>
                    <p>
                      Descripcion:{" "}
                      {this.state.datosPedido?.proyecto.descripcion}
                    </p>
                  </Col>
                  <Col xs={24} sm={24} lg={isMobile ? 24 : 6} xl={isMobile ? 24 : 6}>
                    <h1 style={{ margin: 0 }}>Dirección</h1>
                    {this.state.datosPedido?.proyecto.calle ? (
                      <>
                        <p style={{ margin: 0 }}>
                          Calle: {this.state.datosPedido?.proyecto.calle}
                        </p>
                        <p style={{ margin: 0 }}>
                          Numero:{" "}
                          {this.state.datosPedido?.proyecto.numeroCalle}
                        </p>
                      </>
                    ) : (
                      <>
                        <p style={{ margin: 0 }}>
                          Marca: {this.state.datosPedido?.proyecto.marca}
                        </p>
                        <p style={{ margin: 0 }}>
                          Modelo: {this.state.datosPedido?.proyecto.modelo}
                        </p>
                        <p style={{ margin: 0 }}>
                          Placas: {this.state.datosPedido?.proyecto.placas}
                        </p>
                      </>
                    )}
                  </Col>
                  <Col xs={24} sm={24} lg={isMobile ? 24 : 6} xl={isMobile ? 24 : 6}>
                    <h1 style={{ margin: 0 }}>
                      Cliente:{" "}
                      {this.state.datosPedido?.cliente.nombre
                        ? this.state.datosPedido?.cliente.nombre +
                        " " +
                        this.state.datosPedido?.cliente
                          .apellidoPaterno +
                        " " +
                        this.state.datosPedido?.cliente.apellidoMaterno
                        : this.state.datosPedido?.cliente.razonSocial}
                    </h1>
                    <p style={{ margin: 0 }}>
                      Rfc: {this.state.datosPedido?.cliente.rfc}
                    </p>
                    <p style={{ margin: 0 }}>
                      Correo: {this.state.datosPedido?.cliente.correo}
                    </p>
                    <p style={{ margin: 0 }}>
                      Telefono:{" "}
                      {this.state.datosPedido?.cliente.telefono}
                    </p>
                    <p style={{ margin: 0 }}>
                      Celular: {this.state.datosPedido?.cliente.celular}
                    </p>
                  </Col>
                  <Col xs={24} sm={24} lg={isMobile ? 24 : 6} xl={isMobile ? 24 : 6}>
                    <p style={{ margin: 0 }}>
                      Contacto:{" "}
                      {this.state.datosPedido?.cliente.nombreContacto}
                    </p>
                    <p style={{ margin: 0 }}>
                      Tel. Contacto:{" "}
                      {this.state.datosPedido?.cliente.telefonoContacto}
                    </p>
                    <p style={{ margin: 0 }}>
                      Correo Contacto:{" "}
                      {this.state.datosPedido?.cliente.correoContacto}
                    </p>
                    <p style={{ margin: 0 }}>
                      Dias de crédito:{" "}
                      {this.state.datosPedido?.cliente.diasCredito}
                    </p>
                  </Col>
                </Row>
              )}
              <Divider style={{ marginBottom: 10, marginTop: 5 }} />
              <Row >
                <Col span={12} >
                  {this.state.modoMasivo ? (
                    <p style={{ marginBottom: 10 }}>
                      La fecha de entrega de cada insumo se toma del pedido al que pertenece (columna "Fecha Entrega"), puede ajustarse por línea.
                    </p>
                  ) : (
                    <FormItem
                      label="Fecha de Entrega"
                      name="fechaEntrega"
                      required
                      margin
                      initialValue={moment()}
                    >
                      <DatePickerItem
                        placeholder="Fecha de Entrega"
                        allowClear={false}
                      />
                    </FormItem>
                  )}
                  <FormItem
                    label="Observaciones"
                    name="observaciones"
                    margin
                    pattern
                  >
                    <TextAreaItem placeholder="Observaciones" />
                  </FormItem>
                  {!this.state.modoMasivo &&
                    <Checkbox onChange={this.toggleCopiarObservacionesPedido.bind(this)} style={{ marginBottom: 10 }}>
                      Copiar observaciones del pedido
                    </Checkbox>}
                </Col>
                <Col span={12}>
                  <FormItem
                    label="Separar Ins:"
                    name="separarInsumos"
                    margin
                    initialValue={true}
                    valuePropName="checked"
                    tooltip="¿Esto indicara al momento de recibir la orden de compra, que se separen los insumos?"
                  >
                    <SwitchItem />
                  </FormItem>
                  <FormItem
                    label="Importancia"
                    name="importancia"
                    tooltip="Nivel de importancia: 1 = Baja, 2 = Media, 3 = Alta"
                    margin
                    initialValue={2}
                  >
                    <SelectItem placeholder="Seleccione nivel de importancia" style={{ width: "100%" }}>
                      <Option value={1}>
                        <Tag color="green" style={{ marginRight: 8 }}>
                          <ArrowUpOutlined /> Baja
                        </Tag>
                      </Option>
                      <Option value={2}>
                        <Tag color="orange" style={{ marginRight: 8 }}>
                          <WarningOutlined /> Media
                        </Tag>
                      </Option>
                      <Option value={3}>
                        <Tag color="red" style={{ marginRight: 8 }}>
                          <FireOutlined /> Alta
                        </Tag>
                      </Option>
                    </SelectItem>
                  </FormItem>
                </Col>
              </Row>
              <FormInitial.List name="insumos">
                {(fields) => (
                  <>
                    <div style={{ overflowX: 'auto' }}>
                      <table className="table" style={{ minWidth: isMobile ? "900px" : "100%" }}>
                        {fields.length > 0 ? (
                          <thead>
                            <tr>
                              <th className="th-border" style={{ width: "15%" }}>
                                Insumo
                              </th>
                              <th className="th-border" style={{ width: "10%" }}>
                                Proyecto
                              </th>
                              {this.state.modoMasivo &&
                                <th className="th-border" style={{ width: "10%" }}>
                                  Fecha Entrega
                                </th>}
                              {!isMobile &&
                                <th className="th-border" style={{ width: "10%" }}>
                                  Precio Unitario
                                </th>}
                              {!isMobile &&
                                <th className="th-border" style={{ width: "10%" }}>
                                  Inventario
                                </th>}
                              {!isMobile &&
                                <th className="th-border" style={{ width: "10%" }}>
                                  Apartado
                                </th>}
                              {!isMobile &&
                                <th className="th-border" style={{ width: "10%" }}>
                                  Entregado
                                </th>}
                              {!isMobile &&
                                <th className="th-border" style={{ width: "10%" }}>
                                  Cantidad Pedida
                                </th>}
                              <th className="th-border" style={{ width: "6%" }}>
                                Obs.
                              </th>
                              {this.props.permisoApartarInsumosPedido &&
                                <th className="th-border" style={{ width: "10%" }}>
                                  Apartar
                                  <Tooltip title='Poner el máximo disponible en todas las líneas'>
                                    <InboxOutlined onClick={this.llenarMaximoApartarTodos} style={{ marginLeft: '5px', color: '#fa8c16', cursor: 'pointer' }} />
                                  </Tooltip>
                                </th>}
                              <th className="th-border" style={{ width: "10%" }}>
                                Cantidad a requerir
                                <Row gutter={0} justify="center">
                                  <Col span={8}>
                                    <Tooltip title='Requerir el faltante de todos los insumos'>
                                      <CalculatorOutlined onClick={() => this.calcularTodosLosInsumos('faltante')} style={{ marginLeft: '5px', color: 'green' }} />
                                    </Tooltip>
                                  </Col>
                                  <Col span={8}>
                                    <Tooltip title='Requerir el total de todos los insumos'>
                                      <CalculatorOutlined onClick={() => this.calcularTodosLosInsumos('total')} style={{ marginLeft: '5px', color: '#00b5e2' }} />
                                    </Tooltip>
                                  </Col>

                                </Row>

                              </th>
                            </tr>
                          </thead>
                        ) : null}
                        {fields.map(({ key, name, fieldKey, ...restField }, arrayKey) => {
                          const totalColumnas = 1 + 1 + (isMobile ? 0 : 5) + (this.state.modoMasivo ? 1 : 0) + (this.props.permisoApartarInsumosPedido ? 1 : 0) + 1 + 1;
                          const insumoActual = this.state.datosPedido?.insumos[fieldKey];
                          const insumoAnterior = arrayKey > 0 ? this.state.datosPedido?.insumos[fieldKey - 1] : null;
                          const esNuevoGrupo = this.state.modoMasivo &&
                            (arrayKey === 0 || insumoActual?.pedidoId !== insumoAnterior?.pedidoId);
                          return (
                          <tbody key={fieldKey}>
                            {esNuevoGrupo &&
                              <tr>
                                <td colSpan={totalColumnas} className="td-border" style={{ background: "#fafafa", fontWeight: "bold" }}>
                                  {(insumoActual?.pedidoNumero || "—") + " — " + (insumoActual?.clienteNombre || "")}
                                </td>
                              </tr>}
                            <tr>
                              <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "insumoId"]}
                                  fieldKey={[fieldKey, "insumoId"]}
                                  required
                                  noStyle
                                >
                                  <SelectItem
                                    sinBorde
                                    style={{ width: "100%" }}
                                    placeholder="Insumo"
                                    disabled
                                  >
                                    {this.state.objetoInsumos}
                                  </SelectItem>
                                </FormItem>
                              </td>
                              <td className="td-border">
                                {this.nombreProyecto(insumoActual?.proyectoId)}
                              </td>
                              {this.state.modoMasivo && <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "fechaEntrega"]}
                                  fieldKey={[fieldKey, "fechaEntrega"]}
                                  required
                                  noStyle
                                >
                                  <DatePickerItem
                                    sinBorde
                                    placeholder="Fecha de Entrega"
                                    allowClear={false}
                                  />
                                </FormItem>
                              </td>}
                              {!isMobile && <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "precioUnitarioAjustado"]}
                                  fieldKey={[fieldKey, "precioUnitarioAjustado"]}
                                  noStyle
                                >
                                  <InputNumberItem
                                    sinBorde
                                    placeholder="Precio Unitario"
                                    disabled
                                    dineroDisabled
                                  />
                                </FormItem>
                              </td>}
                              {!isMobile && <td className="td-border">
                                <Tooltip title={`Real ahora mismo: ${insumoActual?.inventario || 0}  −  lo que se lleva TODO lo escrito en "Apartar" de este mismo insumo+proyecto en las demás líneas`}>
                                  <InputNumberItem
                                    sinBorde
                                    placeholder="Inventario"
                                    value={this.calcularPreviewFila(fieldKey).inventarioPreview}
                                    disabled
                                  />
                                </Tooltip>
                              </td>}
                              {!isMobile && <td className="td-border">
                                <Tooltip title={`Ya apartado: ${insumoActual?.apartado || 0}  +  Nuevo (lo que escribiste en Apartar): ${this.state.apartarCantidades[fieldKey] || 0}  =  Total: ${this.calcularPreviewFila(fieldKey).apartadoPreview}`}>
                                  <InputNumberItem
                                    sinBorde
                                    placeholder="Apartado"
                                    value={this.calcularPreviewFila(fieldKey).apartadoPreview}
                                    disabled
                                  />
                                </Tooltip>
                              </td>}
                              {!isMobile && <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "entregado"]}
                                  fieldKey={[fieldKey, "entregado"]}
                                  noStyle
                                >
                                  <InputNumberItem
                                    sinBorde
                                    placeholder="Entregado"
                                    disabled
                                  />
                                </FormItem>
                              </td>}
                              {!isMobile && <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "cantidad"]}
                                  fieldKey={[fieldKey, "cantidad"]}
                                  noStyle
                                >
                                  <InputNumberItem
                                    sinBorde
                                    placeholder="Cantidad Pedida"
                                    disabled
                                  />
                                </FormItem>
                              </td>}
                              <td className="td-border">
                                <FormItem noStyle shouldUpdate>
                                  {({ getFieldValue }) => {
                                    const arrayValue = getFieldValue("insumos") || [];
                                    if (!arrayValue[arrayKey]?.insumoId || !this.state.todasInsumos) return null;
                                    return (
                                      <Tooltip
                                        title="Agregar Observaciones"
                                        placement="top"
                                        overlayInnerStyle={{ fontSize: "10px" }}
                                      >
                                        <ButtonItem
                                          type="primary"
                                          size="small"
                                          cyan2
                                          icon={<CommentOutlined />}
                                          verde={arrayValue[arrayKey]?.observaciones}
                                          onClick={() => this.abrirObservaciones(arrayKey)}
                                        />
                                      </Tooltip>
                                    );
                                  }}
                                </FormItem>
                              </td>
                              {this.props.permisoApartarInsumosPedido && (() => {
                                const sinProyecto = !insumoActual?.proyectoId;
                                const conLotes = this.estaBloqueadoPorLotes(insumoActual?.insumoId);
                                const bloqueado = sinProyecto || conLotes;
                                const motivoBloqueo = sinProyecto
                                  ? "Esta línea no tiene proyecto asignado"
                                  : conLotes
                                    ? "Insumo con lotes/marbetes: apártalo desde 'Apartar Insumos'"
                                    : null;
                                const maxApartar = bloqueado ? 0 : this.maxApartarLinea(fieldKey);
                                return (
                                  <td className="td-border">
                                    {bloqueado ? (
                                      <Tooltip title={motivoBloqueo}>
                                        <InputNumberItem sinBorde placeholder="—" disabled />
                                      </Tooltip>
                                    ) : (
                                      <InputNumberItem
                                        sinBorde
                                        placeholder={"Máx: " + maxApartar}
                                        value={this.state.apartarCantidades[fieldKey] || undefined}
                                        min={0}
                                        max={maxApartar}
                                        onChange={(value) => this.onChangeApartarCantidad(fieldKey, value)}
                                      />
                                    )}
                                  </td>
                                );
                              })()}
                              <td className="td-border">
                                <Row>
                                  <Col span={14}>
                                    <FormItem shouldUpdate noStyle>
                                      {() => {
                                        const { apartadoPreview } = this.calcularPreviewFila(fieldKey);
                                        let cantidad =
                                          round10Decimals((this.state.datosPedido?.insumos[
                                            fieldKey
                                          ]?.cantidad || 0) - apartadoPreview);
                                        return (
                                          <FormItem
                                            {...restField}
                                            name={[name, "requerir"]}
                                            fieldKey={[fieldKey, "requerir"]}
                                            numberCero
                                            noStyle
                                            max={cantidad}
                                            type="number"
                                          >

                                            <InputNumberItem
                                              sinBorde
                                              placeholder={"Max: " + cantidad}
                                            />

                                          </FormItem>

                                        );
                                      }}
                                    </FormItem>

                                  </Col>
                                  <Col span={10}>
                                    <Row>
                                      <Col span={8}>
                                        <Tooltip title='Requerir el faltante'>
                                          <CalculatorOutlined onClick={() => this.calcularRequerirFaltante(fieldKey)} style={{ marginLeft: '5px', color: 'green' }} />
                                        </Tooltip>
                                      </Col>
                                      <Col span={8}>
                                        <Tooltip title='Requerir el total'>
                                          <CalculatorOutlined onClick={() => this.calcularRequerirTotal(fieldKey)} style={{ marginLeft: '5px', color: '#00b5e2' }} />
                                        </Tooltip>
                                      </Col>

                                    </Row>
                                  </Col>
                                </Row>
                              </td>
                            </tr>
                            <FormItem
                              noStyle
                              shouldUpdate={(prev, curr) =>
                                prev.insumos?.[arrayKey]?.observaciones !== curr.insumos?.[arrayKey]?.observaciones
                              }
                            >
                              {({ getFieldValue }) => {
                                const arrayValue = getFieldValue("insumos") || [];
                                if (!arrayValue[arrayKey]?.observaciones) return null;
                                return (
                                  <tr>
                                    <td colSpan={totalColumnas} className="td-border-sin-right">
                                      <div style={{ display: "flex", justifyContent: "left", alignItems: "left", backgroundColor: "white" }}>
                                        <div style={{ width: "90%", textAlign: "left", paddingLeft: 20 }}>
                                          {String(arrayValue[arrayKey].observaciones)
                                            .split(/\r?\n/)
                                            .map((line, i) => (
                                              <span key={i}>{line}<br /></span>
                                            ))}
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              }}
                            </FormItem>
                          </tbody>
                          );
                        })}
                      </table>
                    </div>
                  </>
                )}
              </FormInitial.List>
            </Form>
          </Spin>
          <ElegirObservaciones
            visible={this.state.modalObservaciones}
            cerrarElegirObservaciones={this.cerrarObservaciones.bind(this)}
            observaciones={this.state.modalObservacionesObservaciones}
            observacionesPasadas={this.state.modalObservacionesObservacionesPasadas}
            noXml
            clienteIdActual={this.state.clienteIdActual}
          />
          <ModalApartadoPedidoPdf
            visible={this.state.modalApartadoPdf}
            pedidoId={this.state.id}
            apartadoAhora={this.state.apartadoAhora}
            cerrar={this.cerrarApartadoPdf.bind(this)}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    pdfApartadoPedido: state.empresa.pdfApartadoPedido,
    permisoApartarInsumosPedido:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "68e49edf75bb93249195301f"
      )?.activado,
  };
};

export default connect(mapStateToProps)(RequerirInsumosPedido);
